import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import PropTypes from "prop-types";



export default function MyRadio(props) {
	const handleChange = (e) => {
		e.persist();
		props.onChange(e.target.value, props.name);
	};
	return (
		<div>
			<FormControl component="fieldset" >
				<RadioGroup color="primary" row={props.row} value={props.value} onChange={handleChange}>
					{
						props.options.map(option=>
							<FormControlLabel color="primary" key={option.id || option.value} value={option.value} control={<Radio color="primary" checked={option.value===props.value} />} label={option.label} />
						)
					}
				</RadioGroup>
			</FormControl>
        
		</div>
	);
}

MyRadio.propTypes = {
	name: PropTypes.string,
	onChange: PropTypes.func,
	value: PropTypes.bool,
	row: PropTypes.bool,
	options: PropTypes.array
};